// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__oXACk","name":"ConsentHeader_name__3oSVg","birthday":"ConsentHeader_birthday__24taU","skeleton":"ConsentHeader_skeleton__1lVg_"};